/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';
import AdtDashboardIcon from 'icons/AdtDashboardIcon';

const messages = defineMessages({
  title: {id: 'navigation.data-integrations.adt-dashboard'},
});

const AdtDashboardItem = () => (
  <RouteLinkItem
    iconBefore={AdtDashboardIcon}
    route="midas/data-integrations/adt-dashboard"
    title={messages.title}
  />
);

export default AdtDashboardItem;
